/**
 * Click & Reserve: the contact data of the reservation.
 *
 * Markup contract:
 *   <div x-data="reservationCheckout({ editing: false })">
 *     <ul id="addressText" x-show="!editing">… <a @click="edit()">change</a></ul>
 *     <fieldset id="addressForm" x-show="editing">…</fieldset>
 *
 * The customer sees the stored address and opens the form to change it. The form
 * opens by itself when the shop answered with field errors or still wants a phone
 * number — the store calls before it puts an item aside, so the number is the one
 * field the reservation adds to the account data.
 */
document.addEventListener('alpine:init', () => {
    Alpine.data('reservationCheckout', ({ editing = false } = {}) => ({
        editing,

        edit() {
            this.editing = true;

            this.$nextTick(() => {
                const phone = document.getElementById('billingPhone');
                if (phone.value === '') {
                    phone.focus();
                    phone.scrollIntoView({ block: 'center', behavior: 'smooth' });
                }
            });
        },
    }));
});
